import { Icon } from "@opendash/icons";
import { Button, Drawer, List, TreeSelect, Typography } from "antd";
import * as React from "react";
import { useSource, useTranslation } from "..";
export function SourcePicker({ value, onChange, style, asButton = false, allowClear = false, showLine = false, defaultExpanded = true, }) {
    const [, , sources] = useSource();
    const [showDrawer, setShowDrawer] = React.useState(false);
    const treeData = React.useMemo(() => mapSources(sources), [sources]);
    const t = useTranslation();
    return (React.createElement(React.Fragment, null,
        !asButton && (React.createElement(TreeSelect, { style: style, disabled: sources.length < 2, value: value === null || value === void 0 ? void 0 : value.id, onChange: (id) => onChange(sources.find((source) => source.id === id)), treeData: treeData, treeDefaultExpandAll: defaultExpanded, treeNodeFilterProp: "title", showSearch: true, allowClear: allowClear, treeLine: showLine })),
        asButton && (React.createElement(React.Fragment, null,
            React.createElement(Button, { style: Object.assign(Object.assign({}, style), { color: "var(--opendash-color-gray)" }), ghost: true, icon: React.createElement(Icon, { icon: "fa:angle-down" }), onClick: () => {
                    setShowDrawer(true);
                } },
                React.createElement(Typography.Text, { ellipsis: true }, value === null || value === void 0 ? void 0 : value.name)),
            React.createElement(Drawer, { open: showDrawer, closable: true, title: t("opendash:sources.label_plural"), placement: "top", height: "70%", onClose: () => {
                    setShowDrawer(false);
                } },
                React.createElement(List, { size: "large", dataSource: treeData, renderItem: (item) => {
                        return renderItem(item, 0, (id) => {
                            onChange(sources.find((source) => source.id === id));
                            setShowDrawer(false);
                        });
                    } }))))));
}
function renderItem(item, level, select) {
    return (React.createElement(React.Fragment, null,
        React.createElement(List.Item, { onClick: () => {
                select(item.value);
            }, style: { marginLeft: "" + level * 20 + "px" } },
            item.title,
            React.createElement("span", { style: { float: "right" } },
                React.createElement(Icon, { icon: "fa:chevron-right" }))),
        item.children.map((child) => {
            return renderItem(child, level + 1, select);
        })));
}
function mapSources(sources, parent = null, inTree = []) {
    return sources
        .filter((source) => {
        if (inTree.includes(source.id)) {
            return false;
        }
        if (!parent) {
            return !source.parent;
        }
        else {
            return source.parent === parent;
        }
    })
        .map((source) => {
        return {
            title: source.name,
            value: source.id,
            children: mapSources(sources, source.id, [...inTree, source.id]),
        };
    });
}
//# sourceMappingURL=SourcePicker.js.map